import { useMutation } from '@tanstack/react-query';
import { useLocation } from 'react-router-dom';
import { ampli } from '../../../../../ampli';
import { postImage } from '../../../../../api/etc/upload/mutations/postImage';

export const usePostImageMutation = () => {
  const location = useLocation();

  return useMutation(postImage, {
    onError: (error: Error) =>
      ampli.에러발생({
        '에러 내용': error.toString(),
        '에러 종류': '판매 트랙터 이미지 업로드 실패',
        '에러가 발생한 URL': location.pathname,
      }),
  });
};
